module.exports = __webpack_public_path__ + "img/imageDrag.9f22deb8.svg";